export default function initHeaderFocus() {
  const header = document.querySelector('#header');
  const menubar = header?.querySelector('.menu-slide');
  const menuList = header?.querySelector('.nav-menu-holder');
  const listBtns = header?.querySelector('.header-actions.is-desktop');

  if (!header || !menubar || !menuList || !listBtns) return;

  const body = document.body;

  const handleDocumentFocus = (event) => {
    if (body.classList.contains('menu-active') && !menubar.contains(event.target) && !menuList.contains(event.target)) {
      body.classList.remove('menu-active');
    }
  };

  const orderMenu = () => {
    if (window.innerWidth < 1280) {
      menubar.insertBefore(listBtns, menubar.firstChild);
    } else {
      menubar.append(listBtns);
    }
  };

  const initListeners = () => {
    document.addEventListener('focusin', handleDocumentFocus);
    window.addEventListener('resize', orderMenu);
  };

  initListeners();
  orderMenu();
}
